<div
  class="flex"
  [class.flex-col]="vertical"
  [class.items-center]="!vertical"
  [class]="isRating() && vertical ? 'min-h-[90px] items-start' : ''"
>
  @if (before) {
    <ng-container *ngTemplateOutlet="val" />
  }
  @if (isRating()) {
    <div class="flex -mx-[calc(var(--mobi-ui-scale-unit)*2)] flex-wrap">
      @for (i of range(); track i) {
        @if (i > 0) {
          <button
            class="star min-h-[calc(12*(var(--mobi-ui-scale-unit)))] aspect-1 px-[calc(var(--mobi-ui-scale-unit)*2)]"
            [class.hovered]="i <= hovered()"
            [class.active]="i <= value() && hovered() < 0"
            (mouseenter)="hovered.set(i)"
            (focus)="hovered.set(i)"
            (mouseleave)="hovered.set(-1)"
            (blur)="hovered.set(-1)"
            (click)="onUserChange(i)"
            (keydown.enter)="value.set(i)"
            [attr.data-value]="i"
          >
            <svg viewBox="0 0 34 34" fill="none">
              <path
                d="M17.2316 27.8205L16.9989 27.6982L16.7662 27.8205L7.96617 32.4479L7.96615 32.4479C7.25667 32.821 6.42823 32.2191 6.56355 31.4291C6.56355 31.4291 6.56356 31.429 6.56356 31.429L8.24435 21.6303L8.28879 21.3712L8.10057 21.1877L0.98137 14.2475L0.981348 14.2474C0.406904 13.6875 0.724232 12.7132 1.51669 12.5982L1.51679 12.5982L11.3567 11.1682L11.6168 11.1304L11.7331 10.8946L16.133 1.97892C16.4881 1.2601 17.5127 1.26128 17.8659 1.97843L17.8661 1.97876L22.2661 10.8946L22.3824 11.1304L22.6426 11.1682L32.4824 12.5982L32.4825 12.5982C33.275 12.7132 33.5923 13.6875 33.0179 14.2474L33.0179 14.2475L25.8987 21.1877L25.7104 21.3712L25.7549 21.6303L27.4357 31.429C27.4357 31.429 27.4357 31.4291 27.4357 31.4291C27.571 32.2191 26.7426 32.821 26.0331 32.4479L26.033 32.4479L17.2316 27.8205Z"
              />
            </svg>
          </button>
        }
      }
    </div>
  } @else {
    <input
      class="flex-1"
      type="range"
      [attr.min]="min()"
      [attr.max]="max()"
      [value]="value()"
      [attr.step]="step()"
      (input)="onUserChange(getInputValueAsNumber($event))"
    />
  }
  @if (after) {
    <ng-container *ngTemplateOutlet="val" />
  }
</div>

<ng-template #val>
  <span
    [class.mobi-ui-padding-l-sm]="!vertical"
    [class.mobi-ui-padding-t-xxxs]="vertical"
  >
    @if (isRating() && (value() > 0 || hovered() > 0)) {
      {{ valueText() }}
    }
    @if (!isRating()) {
      {{ value() }}
    }
  </span>
</ng-template>
